module.exports = __webpack_public_path__ + "static/ricardo-68bc03035a0da2d655e8e177f1912421.jpg";